import React, { useState, useEffect } from 'react';
import { fetchMonthlyWorkcellActivity } from '../api';
import { useNavigate, useParams } from 'react-router-dom';
import MonthlyViewLayout from '../components/MonthlyViewLayout';
import MonthlyWorkcellScheduler from '../components/MonthlyWorkcellScheduler';
import { toMonthStart } from '../utils/month';
import { formatLocalDate } from '../utils/localDateTime';

const MonthlyWorkcellSchedulePage = () => {
    const [activities, setActivities] = useState([]);
    const navigate = useNavigate();
    const { date, workcell_id } = useParams();
    const rawDate = date || formatLocalDate(new Date());
    const firstDayOfMonth = toMonthStart(rawDate);
    const selectedDate = firstDayOfMonth;

    // Redirect to first day of month if needed
    useEffect(() => {
        if (rawDate !== firstDayOfMonth) {
            navigate(`/chart/monthly/workcell-schedule/${firstDayOfMonth}`, { replace: true });
            return;
        }
    }, [rawDate, firstDayOfMonth, navigate]);

    useEffect(() => {
        const loadData = async () => {
            try {
                const data = await fetchMonthlyWorkcellActivity(firstDayOfMonth);
                // console.log(data)
                setActivities(data);
            } catch (error) {
                console.error('Error loading monthly workcell activity:', error);
            }
        };

        loadData();
    }, [firstDayOfMonth]);

    const handleDateChange = (newDate) => {
        const formattedDate = formatLocalDate(newDate);
        navigate(`/chart/monthly/workcell-schedule/${toMonthStart(formattedDate)}`);
    };

    return (
        <MonthlyViewLayout date={selectedDate}>
            <MonthlyWorkcellScheduler
                activities={activities}
                onDateChange={handleDateChange}
                date={selectedDate}
                workcellId={workcell_id}
            />
        </MonthlyViewLayout>
    );
};

export default MonthlyWorkcellSchedulePage;
